import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CircularProgress,
} from '@mui/material';
import RadioButtonsGroup from '../../../common/RadioButtonsGroup/RadioButtonsGroup';
import { OptimizerOptionProps } from '../../../../types/optimizerTable';
import {
  AlternativesTable,
  AlternativesTitle,
  ChatButton,
  CheckboxContainer,
  CustomCheckbox,
  Description,
  FindingsContainer,
  FindingsText,
  FindingsTitle,
  OptionActions,
  OptionContainer,
  OptionContainerInner,
  OptionsContainer,
  OptionsContainerInner,
} from './OptimizerTable.styles';
const OptimizerOption = ({
  opt,
  handleBtnAskClick,
  handleCheckboxChange,
  optimizeData,
  setOptimizeData,
  id,
  isOpen,
  loading,
  title,
  setLoading,
  averagePrice,
  handleOpenChat,
  getMessagesForTopic,
  saveMessagesForTopic,
  askChat,
  isLast = false,
}: OptimizerOptionProps) => {
  const { t } = useTranslation('optimizer');
  const description = opt.description || opt.title;
  return (
    <React.Fragment key={opt.id}>
      <OptionContainer isLast={isLast}>
        <OptionContainerInner>
          <OptionActions>
            {opt.isChat === 'ask' ? (
              <ChatButton
                variant="contained"
                size="small"
                onClick={() => handleBtnAskClick({
                  targetTitle: title,
                  price: averagePrice,
                  option: opt.title,
                  optionId: opt.id,
                  setLoading: setLoading,
                  loading: loading,
                  onOpenChat: handleOpenChat,
                  getMessagesForTopic,
                  saveMessagesForTopic,
                  askChat,
                })}
                disabled={loading[opt.title]}
              >
                {loading[opt.title] ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  t('table.openInChat')
                )}
              </ChatButton>
            ) : (
              <CheckboxContainer>
                <CustomCheckbox
                  color="primary"
                  checked={!!opt.enabled}
                  onClick={(e) => handleCheckboxChange({
                    event: e,
                    id: opt.id,
                    selected: [],
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    setSelected: () => {},
                    records: optimizeData,
                    rowId: id,
                    setRecordsData: setOptimizeData,
                  })}
                  inputProps={{
                    'aria-labelledby': opt.id.toString(),
                  }}
                />
              </CheckboxContainer>
            )}
          </OptionActions>
          <Description
            onClick={opt.isChat !== 'ask' ? () => handleCheckboxChange({
              event: {} as React.MouseEvent<unknown>,
              id: opt.id,
              selected: [],
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              setSelected: () => {},
              records: optimizeData,
              rowId: id,
              setRecordsData: setOptimizeData,
            }) : undefined}
            sx={opt.isChat !== 'ask' ? { cursor: 'pointer' } : undefined}
          >
            {description}
          </Description>
        </OptionContainerInner>
        {isOpen && opt.findings && (
          <FindingsContainer>
            <FindingsTitle>
              {t('table.findings')}
            </FindingsTitle>
            <FindingsText>
              {opt.findings}
            </FindingsText>
          </FindingsContainer>
        )}
        {isOpen && opt.optCostsResults && opt.optCostsResults.length > 0 && (
          <OptionsContainer>
            <OptionsContainerInner>
              <AlternativesTitle>
                {t('table.alternativesOnMarket')}
              </AlternativesTitle>
              <AlternativesTable>
                <RadioButtonsGroup
                  alternativeId={opt.id}
                  rowId={id}
                  records={optimizeData}
                  setRecordsData={setOptimizeData}
                />
              </AlternativesTable>
            </OptionsContainerInner>
          </OptionsContainer>
        )}
      </OptionContainer>
    </React.Fragment>
  );
};
export default OptimizerOption;
